<div *ngFor="let warning of INDRA_getWarnings()" class="details-block__warning" role="status" [class.hide-warning]="warning === 'hidden'">
	<app-svg class="details-block__warning-icon" 
		svg="icons.svg#airport--delays" 
		aria-hidden="true" 
		[alt]="'Alert icon'">
	</app-svg>
	<button *ngIf="warning.type; else msgText" 
		(click)="INDRA_handleOpenDetailsSidebar()" 
		class="link" 
		[attr.aria-label]="('bookingDetails.aria.openDialogToAdd' | ibeadmin | async) + warning.type + ('bookingDetails.aria.details' | ibeadmin | async)" 
		role="button"
	>
		<span skeletonLoader [translationKey]="'bookingDetails.text.add'">
			{{ 'bookingDetails.text.add' | ibeadmin | async }} {{ warning.type }} {{ 'bookingDetails.text.details' | ibeadmin | async }}
		</span>
	</button>
	<ng-template #msgText>
		<span class="text">
			{{ warning }}
		</span>
	</ng-template>
</div>
<div *ngIf="userData && isAward" [ngStyle]="INDRA_warningSpace()" class="warning-block">
	<app-svg class="warning-icon" svg="icons.svg#airport--delays" aria-hidden="true" [alt]="'Alert icon'"></app-svg>
	<div>
		<p class="warning-text">
			<span skeletonLoader [translationKey]="'bookingPayment.text.warningOnlyAfterPayment'">
				{{'bookingPayment.text.warningOnlyAfterPayment' | ibeadmin | async}}, <span class="passenger-warning-message">{{INDRA_printDisplayName() | uppercase}}</span> {{'bookingPayment.text.warningWillJoinBeneficiary' | ibeadmin | async}}.
			</span>
		</p>
	</div>
</div>
<article class="details-block details-block--passenger" 
	[ngClass]="{'has-details': INDRA_hasPassengerDetails(), 'no-pointer-events' : no_edit && no_detail}" 
	tabindex=0 
	[attr.aria-label]="('bookingDetails.aria.detailsOfPassenger' | ibeadmin | async) + INDRA_printDisplayName()">
	
	<div class="details-block__content">
		<div class="details-block__header" [ngStyle]="INDRA_printLinkClasses()">
			<div class="details-block__title">
				<h3 class="title-h5" *ngIf="INDRA_hasPassengerDetails()"> 
					{{ INDRA_printDisplayName() }}
				</h3>
				<span class="label muted" skeletonLoader [translationKey]="INDRA_printType()">
					{{ INDRA_printType() | ibeadmin | async }} {{ INDRA_printTypeCount() }}
				</span>
				<div *ngIf="INDRA_hasPassengerDetails() && INDRA_displayLogo()">
					<div *ngIf="showLogo">
							<app-svg class="user-logo"
							alt="'Miles&Go logo'" 
							svg="sprite.svg#{{ logo }}"
							aria-hidden="true">
						</app-svg>
					</div>
				</div>
				<div *ngIf="INDRA_getTicketNumber()">
					<span class="label">
						<span skeletonLoader [translationKey]="'bookingDetails.text.Ticket'">
							{{ 'bookingDetails.text.Ticket' | ibeadmin | async }}:
						</span>
					</span>
					<span class="value">{{ INDRA_getTicketNumber() }}</span>
				</div>
			</div>
			<div *ngIf="INDRA_hasDetails() && !no_edit && !INDRA_isPending()" class="details-block__edit">
				<button (click)="INDRA_handleOpenDetailsSidebar()"
					class="link" 
					[attr.aria-label]="('bookingDetails.aria.openToEditPassengerDetails' | ibeadmin | async)"
					role="button"
				>
					<span skeletonLoader [translationKey]="'bookingDetails.text.edit'">
						{{ 'bookingDetails.text.edit' | ibeadmin | async }}
					</span>
				</button>
			</div>
			<div *ngIf="!INDRA_hasDetails() && !no_edit" class="details-block__add">
				<button *ngIf="!INDRA_hasDetails()" 
					(click)="INDRA_handleOpenNewPassengerSidebar()" 
					[disabled]="isPaymentMethodLoading$ | async"
					role="button" 
					class="button" 
					[attr.aria-label]="('bookingDetails.aria.openToAddPassengerDetails' | ibeadmin | async)"
				>
					<span skeletonLoader [translationKey]="'bookingDetails.text.openToAddPassengerDetails'">
						{{ 'bookingDetails.text.openToAddPassengerDetails' | ibeadmin | async }}
					</span>
				</button>
			</div>
		</div>
		<div class="details-block__details" *ngIf="INDRA_hasDocumentOrFFnum()">
			<div *ngIf="INDRA_hasDocument() && INDRA_hasPassengerDocuments()" 
				class="details-block__content-values">
				<span class="label">
					<span skeletonLoader [translationKey]="INDRA_printDocumentType()">
						{{ INDRA_printDocumentType() | ibeadmin | async}}:
					</span>
				</span>
				<span class="value">{{ INDRA_printDocumentNumber() }}</span>
			</div>
			<div *ngIf="INDRA_hasDocumentExpirationDate() && INDRA_hasPassengerDocuments()" 
				class="details-block__content-values">
				<span class="label">
					<span skeletonLoader [translationKey]="'bookingDetails.text.expiryDate'">
						{{ 'bookingDetails.text.expiryDate' | ibeadmin | async }}:
					</span>
				</span>
				<span class="value">{{ INDRA_printDocumentExpiry() }}</span>
			</div>
			<div *ngIf="INDRA_hasFrequentFlyerNumber()" 
				class="details-block__content-values">
				<span class="label">
					<span skeletonLoader [translationKey]="'bookingDetails.text.frequentFlyer'">
						{{ 'bookingDetails.text.frequentFlyer' | ibeadmin | async }}:
					</span>
				</span>
				<span class="value">{{ INDRA_printFrequentFlyer() }}</span>
			</div>
		</div>
	</div>
	
	<div *ngIf="INDRA_hasFlights()">
		<button class="details-block__flights" 
			*ngFor="let flight of flights" 
			(keydown.enter)="INDRA_handleOpenIncludedSidebar(flight)"
			(click)="no_detail ? false : INDRA_handleOpenIncludedSidebar(flight)" 
			role="button" 
			[attr.aria-label]="('bookingDetails.aria.openDialogWithWhatsIncluded' | ibeadmin | async) + INDRA_printAriaRoute(flight) + ('bookingDetails.aria.dialogFlight' | ibeadmin | async)">
			<div class="grid no-gutter details-block__flight" aria-hidden="true">
				<div class="col-6 align-left">
					<app-svg class="details-block__flights-icon" 
						svg="icons.svg#plane_related--flights" 
						alt="Flight" 
						aria-hidden="true" 
						[alt]="'bookingDetails.alt.flight' | ibeadmin | async">
					</app-svg>
					<span class="details-block__flight-label">
						{{ INDRA_printRoute(flight) }}
					</span>
				</div>
				<div class="col-6 align-right">
					<app-svg *ngIf="INDRA_hasExtrasLuggageInfo(flight)" 
						class="details-block__flights-icon" 
						svg="icons.svg#ancillaries--luggage" 
						aria-hidden="true" 
						[alt]="'bookingDetails.alt.checkedBag' | ibeadmin | async">
					</app-svg>
					<span *ngIf="INDRA_hasExtrasLuggageInfo(flight)" 
						class="details-block__extras-label">
						{{ INDRA_printLuggageInfo(flight) }}
					</span>
					<app-svg *ngIf="INDRA_hasExtrasSeatInfo(flight)" 
						class="details-block__flights-icon" 
						svg="icons.svg#plane_related--seat" 
						aria-hidden="true" 
						[alt]="'bookingDetails.alt.seatNumber' | ibeadmin | async">
					</app-svg>
					<span *ngIf="INDRA_hasExtrasSeatInfo(flight)" 
						class="details-block__extras-label">
						{{ INDRA_printSeatInfo(flight) }}
					</span>
					<app-svg *ngIf="!no_detail" class="details-block__flights-icon 
						details-block__flights-icon-link" 
						svg="icons.svg#general--arrow--right_big" 
						aria-hidden="true" 
						[alt]="'Arrow right'">
					</app-svg>
				</div>
			</div>
		</button>
	</div>
</article>
